import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

const isDevelopment = import.meta.env.DEV;

const getEnvironment = () => {
  const hostname = window.location.hostname;

  if (hostname.includes('test.ocula.tech') || hostname.includes('ocula-webapp-test')) {
    return 'test';
  }

  if (hostname.includes('dev.ocula.tech') || hostname.includes('ocula-webapp-dev')) {
    return 'dev';
  }

  if (hostname.includes('staging.ocula.tech')) {
    return 'staging';
  }

  if (hostname.includes('app.ocula.tech')) {
    return 'production';
  }

  return import.meta.env.MODE;
};

if (!isDevelopment) {
  Sentry.init({
    dsn: 'https://4ed552c5240b186642d15440a3316ea8@o4507628513460224.ingest.de.sentry.io/4508817771462736',
    environment: getEnvironment(),
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [
      /^\//,
      /^https:\/\/web-app-bff-.*\.nw\.gateway\.dev/
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
